import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FunnelProgress, { FunnelStep } from "./FunnelProgress";
import Rating from "../../assets/images/rating.png";
import "./CommonNewFunnel.css";

const STEP_KEY = "glp1_intake_current_step";

type Props = {
  children: React.ReactNode;
};

const getStepNumberFromPath = (pathname: string) => {
  const match = pathname.match(/\/step-(\d+)(?:[a-z])?\b/i);
  if (!match) return null;
  const n = Number(match[1]);
  return Number.isFinite(n) ? n : null;
};

const getPhaseFromStep = (stepNum: number | null): FunnelStep | null => {
  if (!stepNum) return "start"; // fallback
  if (stepNum >= 0 && stepNum <= 1) return "start";
  if (stepNum >= 2 && stepNum <= 8) return "details";
  if (stepNum >= 9 && stepNum <= 10) return "eligibility";
  if (stepNum >= 11) return null;
  return "start";
};

const FunnelLayout: React.FC<Props> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const stepNum = useMemo(
    () => getStepNumberFromPath(location.pathname),
    [location.pathname]
  );

  const phase = useMemo(() => getPhaseFromStep(stepNum), [stepNum]);

  useEffect(() => {
    if (phase) localStorage.setItem(STEP_KEY, phase);
  }, [phase]);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="funnel-page">
      <div className="funnel-wrapper">
        <header className="funnel-header">
          <div className="funnel-header__logo">
            <img
              className="logo-placeholder"
              src="/images/clogo.png"
              alt="LOGO"
            />
          </div>

          {(stepNum ?? 0) < 12 && (
            <div className="funnel-header__rating">
              <img className="logo-rating" src={Rating} alt="rating" />
            </div>
          )}
        </header>

        {phase && (
          <FunnelProgress
            step={phase}
            onBack={handleBack}
            // ✅ show back from step-2 onwards (so it appears on testimonials step)
            showBack={(stepNum ?? 0) > 0}
          />
        )}

        <main className="funnel-content">{children}</main>
      </div>
    </div>
  );
};

export default FunnelLayout;
